module.exports = __webpack_public_path__ + "img/egame_rich88.d99e59c5.png";